import React from 'react'
import {
  FaSolarPanel,
  FaBolt,
  FaBroadcastTower,
  FaBuilding,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaArrowRight,
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
  FaCoins,
  FaLeaf,
  FaBars,
  FaTimes,
  FaWhatsapp,
  FaPhoneAlt,
  FaArrowLeft,
  FaArrowRight as FaArrowRightIcon,
} from 'react-icons/fa';

const Footer = () => {
  return (
    <>
        <footer
        className=" w-full text-white shadow-lg z-50 py-20"
        style={{
          backgroundImage:
            'linear-gradient(to bottom, #77a130, #81a445, #8aa859, #93ab6b, #9cae7d)',
        }}
      >

        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
            <div>
              <h3 className="text-xl font-semibold mb-4">About Us</h3>
              <p className="text-green-100 mb-4">
                Solarmore Solutions Green Energy Pvt. Ltd. is a pioneering company in the renewable energy sector, specializing in solar power solutions.
              </p>
              <div className="flex items-center">
                <img
                  src="https://static.readdy.ai/image/949d7bbab735c9790fcff9ac6628a17d/de03a81a14bb9393e0e1ee2ead298945.png"
                  alt="Solarmore Logo"
                  className="w-12 h-12 object-contain mr-2"
                />
                <div>
                  <p className="font-bold">Solarmore Solutions</p>
                  <p className="text-sm">GREEN ENERGY Pvt. Ltd.</p>
                </div>
              </div>
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-4">Quick Links</h3>
              <ul className="space-y-2">
                <li>
                  <a href="#" className="text-white transition-colors">
                    Home
                  </a>
                </li>
                <li>
                  <a href="#about" className="text-white transition-colors">
                    About Us
                  </a>
                </li>
                <li>
                  <a href="#services" className="text-white transition-colors">
                    Services
                  </a>
                </li>
                <li>
                  <a href="#gallery" className="text-white transition-colors">
                    Projects
                  </a>
                </li>
                <li>
                  <a href="#contact" className="text-white transition-colors">
                    Contact
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-4">Our Services</h3>
              <ul className="space-y-2">
                <li>
                  <a href="#services" className="text-white transition-colors">
                    Solar Power Plants
                  </a>
                </li>
                <li>
                  <a href="#services" className="text-white transition-colors">
                    Engineering & Procurement
                  </a>
                </li>
                <li>
                  <a href="#services" className="text-white transition-colors">
                    Construction
                  </a>
                </li>
                <li>
                  <a href="#services" className="text-white transition-colors">
                    Operation & Maintenance
                  </a>
                </li>
                <li>
                  <a href="#services" className="text-white transition-colors">
                    Consultancy
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-4">Contact Us</h3>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <FaMapMarkerAlt className="text-5xl text-white mt-1 mr-3" />
                  <span className="text-green-100">
                    1A, Plot No: 28, Karpaganagar Main Street, Ganapathy Nagar, Madurai South, Madurai - 625012.
                  </span>
                </li>
                <li className="flex items-center">
                  <FaPhone className="text-lg text-white mr-3" />
                  <span className="text-green-100">+91 9994223604 / 9047010004</span>
                </li>
                <li className="flex items-center">
                  <FaEnvelope className="text-xl text-white mr-4" />
                  <span className="text-green-100">info@solarmore.in / md@solarmore.in</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="pt-8 border-t border-green-700 flex flex-col md:flex-row justify_between items-center text-center gap-2 md:gap-0">
            <p className="text-white text-center md:text-start">
              SolarMore Solutions Green Energy Pvt. Ltd. © 2025. All rights reserved
            </p>
            <a
              href="https://vivekasoftek.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white text-center md:text-end transition-all duration-300 ease-in-out"
            >
              Powered By{' '}
              <span className="text-white font-medium hover:bg-gray-50 hover:text-green-500 transition-colors duration-300 ease-in-out">
                Madura Group Of Companies
              </span>
            </a>
          </div>
        </div>
      </footer>
    </>
  )
}

export default Footer